import type { SupportedCountry } from '@archipro-website/localisation';
import { getDomain } from './get-domain';

/**
 * Privacy contact alias for a market, e.g. `privacy@archiproamerica.com`.
 *
 * Every market runs the same `privacy@` mailbox on its own apex domain, so the
 * address always follows the site the visitor is on. Callers must resolve it
 * from the current country rather than hardcoding one market's address.
 */
export const getPrivacyContactEmail = (country: SupportedCountry): string =>
    `privacy@${getDomain(country)}`;
